module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_4.6b896188.png";